<template>
  <div :class="['row gx-2', colSpanClass, props.class]">
    <slot></slot>
  </div>
</template>
<script setup>
import { computed } from 'vue';

const props = defineProps({
  class: {
    type: String,
    default: 'align-items-center'
  },
  colSpan: {
    type: Object,
    default: () => null,
  } 
});

  const colSpanClass = computed(() => {
    if (props.colSpan !== null) {
      const classes = [];
      Object.entries(props.colSpan).forEach(([key, value]) => {
        classes.push(`row-cols-${key}-${value}`);
      });
      return classes.join(' ');
    }
    return props.cols ? `row-cols-lg-${props.cols} row-cols-sm-2` : '';
  });
</script>